<div class="wow fadeIn"
     data-wow-duration="500ms">
   <div class="pageBanner capitals"></div>
   <div class="">
      <div class="pageTabs capitalsTabsMain sapientsansmedium font-15">
         <div class="capitalsTabs flex hr-center">
            <div class="platformTabs flex padding-r-30">
               <div class="proximaNovaSb margin-r-20 font-17 highlight-color">Platforms:</div>
               <a routerLink="/capitals/platform-services" class="wow fadeInUp"
                  [ngClass]="{'active': path?.currentRout('/capitals/platform-services')}"
                  data-wow-duration="500ms" data-wow-delay="100ms">Software & Services</a>
               <a routerLink="/capitals/asset" class="wow fadeInUp" [ngClass]="{'active': path?.currentRout('/capitals/asset')}"
                  data-wow-duration="500ms" data-wow-delay="100ms">Asset Management</a>
               <a routerLink="/capitals/fintech" class="wow fadeInUp" [ngClass]="{'active': path?.currentRout('/capitals/fintech')}"
                  data-wow-duration="500ms" data-wow-delay="300ms">FinTech</a>
               <a routerLink="/capitals/sports" class="wow fadeInUp"
                  [ngClass]="{'active': path?.currentRout('/capitals/sports')}"
                  data-wow-duration="500ms" data-wow-delay="300ms">Sports</a>
               <a routerLink="/capitals/details" class="wow fadeInUp" [ngClass]="{'active': path?.currentRout('/capitals/details')}"
                     data-wow-duration="500ms" data-wow-delay="300ms">Mission Capital</a>

            </div>

            <!-- <div class="partnershipTabs flex border-left padding-l-30">
               <div class="proximaNovaSb margin-r-20 font-17 highlight-color">Partnerships:</div>
               <a routerLink="/capitals/asset" class="wow fadeInUp"
                  [ngClass]="{'active': path?.currentRout('/capitals/asset')}"
                  data-wow-duration="500ms" data-wow-delay="100ms">Asset Management</a>
            </div> -->
         </div>
      </div>
   </div>


   <router-outlet></router-outlet>


</div>
